import { BINDING_DISTANCE } from "pages/flyer/builder/drawer/constants/constants";
import * as React from "react";
import { getHexagonPoints } from "../hexagonHelpers";

interface HexagonBindingIndicatorProps {
  size: number[];
}

export function HexagonBindingIndicator({ size }: HexagonBindingIndicatorProps) {
  const hexagonPoints = getHexagonPoints(size).join();
  return <polygon className="tl-binding-indicator" points={hexagonPoints} strokeWidth={BINDING_DISTANCE * 2} />;
}
